import Bowser from 'bowser';
import navigation from '../../constants/navigation';

const isYandexBrowser = () => {
  const userAgent = navigator.userAgent || '';
  return /YaBrowser/i.test(userAgent);
};

const isPathVisitedByAllowedBrowser = (location, options = {}) => {
  const { lessonWaiting, lessonBreak, lessonEnd, videoConference } = navigation;
  const {
    allowedBrowsers = ['Yandex'],
    forbiddenPaths = [lessonWaiting.path, lessonBreak.path, lessonEnd.path, videoConference.path],
  } = options;
  const { pathname } = location ?? {};

  if (!(location && typeof location === 'object' && 'pathname' in location)) {
    throw new Error('Location should be an object with pathname object property');
  }

  const isForbiddenPath = forbiddenPaths.some(path => pathname === path);
  
  if (isForbiddenPath) {
    const { userAgent } = navigator;
    const browser = Bowser.getParser(userAgent);
    const browserName = browser.getBrowserName(true);
    console.log('Browser name:', browserName); // Для отладки
    console.log('Allowed browsers:', allowedBrowsers);
    return allowedBrowsers.some(
      allowedBrowser =>
        browserName.toLowerCase() === allowedBrowser.toLowerCase() ||
        (allowedBrowser.toLowerCase() === 'yandex' && isYandexBrowser()),
    );
  }

  return true;
};

export default isPathVisitedByAllowedBrowser;